module.exports = __webpack_public_path__ + "img/insta-10.1e27b10b.jpg";